// @ts-expect-error untyped module reference-resolvers
import { WORKFLOW } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { classicWorkflowUrl } from 'automation-ui-routing/workflowsUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Don't use this component directly. Instead, use the
 * `WorkflowName` component and pass flowSourceType="CLASSIC"
 *
 * Example:
 *   <ClassicFlowName id="123" />
 * Renders as:
 *   My Workflow Name
 */
const ClassicFlowName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  href: href || classicWorkflowUrl(id),
  id: id,
  messageKey: messageKey,
  referenceObjectType: WORKFLOW
});
export default ClassicFlowName;